"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CommunityPerks() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const values = [{
    number: "01",
    eyebrow: "CORE PILLAR",
    title: "Elite Performance",
    body: "We demand excellence in every frame. Our roster is built on mechanical precision, tactical depth, and the relentless pursuit of the championship title. We don't just play; we dominate the digital arena.",
    summary: "— precision over everything"
  }, {
    number: "02",
    eyebrow: "CORE PILLAR",
    title: "Community First",
    body: "Pixel Force is more than a team; it is a global network. From our Discord command center to our live event meetups, we foster a culture of collaboration, shared strategy, and mutual growth.",
    summary: "— stronger together in the grid"
  }, {
    number: "03",
    eyebrow: "CORE PILLAR",
    title: "Future Forward",
    body: "We are the architects of the next generation of esports. By integrating cutting-edge training tech and immersive fan experiences, we ensure our community stays ahead of the meta, always.",
    summary: "— defining the next era of play"
  }];
  return <section data-section-id="805" id="community-perks" className="bg-background text-foreground py-32 px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-4 w-full max-w-2xl mb-10">
            <div className="h-px flex-1 bg-border" />
            <span className="font-mono text-xs tracking-[0.2em] text-muted-foreground uppercase whitespace-nowrap">
              Tactical Directives • The Pixel Force Standard
            </span>
            <div className="h-px flex-1 bg-border" />
          </div>
          <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[60px] leading-[1.05] tracking-tight text-foreground max-w-4xl">
            Three mandates.
            <br />
            <span className="text-primary">Zero compromise.</span>
          </h2>
        </div>

        {}
        <div ref={gridRef} className="relative grid grid-cols-1 lg:grid-cols-3 gap-6">
          {values.map((value, i) => <div data-index={i} key={value.number} className={`group relative bg-card border border-border p-10 md:p-14 min-h-[480px] flex flex-col transition-all duration-500 hover:shadow-lg ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: gridVisible ? `${i * 120}ms` : "0ms"
        }}>
              {}
              {i < values.length - 1 && <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 flex-col gap-1 z-10">
                  {Array.from({
              length: 7
            }).map((_, t) => <div data-index={t} key={t} className="w-px h-2 bg-border" style={{
              opacity: t === 3 ? 1 : 0.5
            }} />)}
                </div>}

              {}
              <div className="font-default font-bold text-[88px] leading-none mb-8 transition-all duration-500" style={{
            color: "var(--primary)",
            WebkitTextStroke: "1px var(--primary)",
            WebkitTextFillColor: "transparent"
          }}>
                <span className="group-hover:[-webkit-text-fill-color:var(--primary)] transition-all duration-500">
                  {value.number}
                </span>
              </div>

              {}
              <span className="font-mono text-xs tracking-[0.2em] text-primary uppercase mb-4">
                {value.eyebrow}
              </span>

              {}
              <h3 className="font-default font-bold text-3xl md:text-[36px] leading-tight text-foreground mb-6">
                {value.title}
              </h3>

              {}
              <div className="h-px w-10 mb-6 transition-all duration-500 group-hover:w-20" style={{
            backgroundColor: "var(--primary)"
          }} />

              {}
              <p className="text-base leading-relaxed text-muted-foreground font-default flex-grow">
                {value.body}
              </p>

              {}
              <div className="mt-8 pt-6 border-t border-border">
                <p className="font-default italic text-base text-foreground/80">
                  {value.summary}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div ref={footerRef} className={`mt-20 text-center transition-all duration-700 ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <p className="font-default italic text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            These mandates are not just goals. They are our operational code.
          </p>
        </div>
      </div>
    </section>;
}